import type { VeloConfig } from '@wix/cli-site-old-definitions';
import {
  WIX_CONFIG_FILENAME,
  getWixConfigFilePath,
} from '@wix/cli-core-definitions';
import { veloConfigSchema } from '@wix/cli-site-old-definitions';
import { readJson, writeJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function saveVeloConfig(
  projectFolder: string,
  config: VeloConfig
) {
  await writeJson(getWixConfigFilePath(projectFolder), config, {
    spaces: 2,
  });
}

export async function loadVeloConfig(projectFolder: string) {
  const configFile = await readJson(getWixConfigFilePath(projectFolder));

  try {
    return veloConfigSchema.parse(configFile);
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.InvalidVeloConfigJson({
        configFilename: WIX_CONFIG_FILENAME,
      }),
      cause: e,
    });
  }
}
